/**
 * @generated SignedSource<<a4998369b22a83533e6e016e3b52f2cc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type taskList_Query$variables = {
  fetchAssignee: boolean;
  fetchHighLow: boolean;
  fetchRoles: boolean;
  fetchLabels: boolean;
  taskIds: ReadonlyArray<string | null>;
};
export type taskList_Query$data = {
  readonly viewer: {
    readonly actualPersonId: string | null;
    readonly component: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"taskList_viewer">;
  } | null;
};
export type taskList_Query = {
  variables: taskList_Query$variables;
  response: taskList_Query$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fetchAssignee"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fetchHighLow"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fetchLabels"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fetchRoles"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "taskIds"
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualPersonId",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "task_list"
    }
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": "component(name:\"task_list\")"
},
v7 = {
  "kind": "Variable",
  "name": "taskIds",
  "variableName": "taskIds"
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "taskList_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "args": [
              {
                "kind": "Variable",
                "name": "fetchAssignee",
                "variableName": "fetchAssignee"
              },
              {
                "kind": "Variable",
                "name": "fetchHighLow",
                "variableName": "fetchHighLow"
              },
              {
                "kind": "Variable",
                "name": "fetchLabels",
                "variableName": "fetchLabels"
              },
              {
                "kind": "Variable",
                "name": "fetchRoles",
                "variableName": "fetchRoles"
              },
              (v7/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "taskList_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "taskList_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "FeatureFlag",
            "kind": "LinkedField",
            "name": "availableFeatureFlags",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "key",
                "storageKey": null
              },
              (v8/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 10000
              },
              (v7/*: any*/)
            ],
            "concreteType": "TaskTypeConnection",
            "kind": "LinkedField",
            "name": "tasks",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "TaskTypeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Task",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/),
                      {
                        "condition": "fetchHighLow",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "HighLowSuggestions",
                            "kind": "LinkedField",
                            "name": "highLowSuggestion",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "high",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "low",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "estimate",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "fetchRoles",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "roleSuggestion",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "fetchAssignee",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "assigneeSuggestion",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "fetchLabels",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "labelSuggestion",
                            "storageKey": null
                          }
                        ]
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v8/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "95678f492232f9821e26005459f2f6c4",
    "id": null,
    "metadata": {},
    "name": "taskList_Query",
    "operationKind": "query",
    "text": "query taskList_Query(\n  $fetchAssignee: Boolean!\n  $fetchHighLow: Boolean!\n  $fetchRoles: Boolean!\n  $fetchLabels: Boolean!\n  $taskIds: [ID]!\n) {\n  viewer {\n    actualPersonId\n    component(name: \"task_list\")\n    ...taskList_viewer_1FRc8M\n    id\n  }\n}\n\nfragment taskList_viewer_1FRc8M on Viewer {\n  availableFeatureFlags {\n    key\n    id\n  }\n  tasks(taskIds: $taskIds, first: 10000) {\n    edges {\n      node {\n        id\n        highLowSuggestion @include(if: $fetchHighLow) {\n          high\n          low\n          estimate\n        }\n        roleSuggestion @include(if: $fetchRoles)\n        assigneeSuggestion @include(if: $fetchAssignee)\n        labelSuggestion @include(if: $fetchLabels)\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7095a4f270e143cf655e04e725feedb6";

export default node;
